module.exports = __webpack_public_path__ + "static/media/lots4.246a9f30.jpg";